import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import * as wActs from "../actions/website-actions";
import {Link} from 'react-router-dom';
import URL from "url-parse";
import NotFound from "../components/notfound";
class Agency extends Component {

  componentDidMount() {

  }
  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }



  handleReadMore(e) {
    e.preventDefault();
    this.Text.classList.add("active");
    this.ReadMore.classList.add("hide");
  }

  render() {


    if (this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }


    const pageloaded = this.props.WebPage.PageLoaded;
    if(!pageloaded) {return null}
    const loaded = this.props.Agent.Loaded;
    const code = this.props.Agent.Result.Code;
    let url=""; let host="";

    if(!pageloaded || !loaded) {
      return (
        <div className="main-content left">
          <SeoHeaders Position={"Top"}/>
          <div className="company-page thin-white-box">
            <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
              <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
            </p>
          </div>
        </div>
      );
    }

    if(code !== 200) {
      return null;
    }

    const agt = this.props.Agent.Result.Result;

    if(!wActs.isNullOrEmpty(agt.WebPageUrl)) {
      try {
        url = new URL(agt.WebPageUrl);
        host = url.host;
      } catch (ex) {
      }
    }

    const hasImage = !wActs.isNullOrEmpty(agt.LogoUrl);
    let self = this;
    if(hasImage && typeof window !== "undefined") {
      let img = new Image();
      img.onload = function() {
        //console.log("Width",this.width);
        //console.log(this.width/this.height);
        if(this.width/this.height<2) {
          self.AgImage.src=agt.LogoUrl.replace("preview","source");
          self.ImgWrapper.classList.remove("hide");
          self.TextContent.classList.remove("onehundredpercent");
        } else {
          self.AgImage.src="";
          self.ImgWrapper.classList.add("hide");
          self.TextContent.classList.add("onehundredpercent");
        }
      };
      img.src=agt.LogoUrl.replace("preview","source");
    }
    return (
      <div className="main-content left">
        <SeoHeaders Position={"Top"}/>
        <div className="company-page thin-white-box">
            <div className="company-profile-top">
              <div ref={(ref) => {this.ImgWrapper = ref}} className="gallery-wrapper">
              <div className="company-picture"><img ref={(ref) => { this.AgImage = ref }} src="/imgs/spacer.gif" alt={this.props.WebPage.Page.AltText.replace("{{Number}}","1")}/></div>
              </div>
              <div ref={(ref) => {this.TextContent = ref}} className="text-content">
                <div className="agency-header">
                  <h2>{agt.Name}</h2>
                  {agt.WorkingLocations.length>0 &&
                  <span className="location"><i className="fas fa-map-marker-alt"></i>
                    {agt.WorkingLocations.map((v,i) => {
                      let city = wActs.isNullOrUndefined(v.City) ? "" : wActs.isNullOrEmpty(v.City.Name) ? "" : ", " + v.City.Name;
                      return <span key={"pace-" + i}>{v.Country.Name}{city}</span>
                    })}
                  </span>
                  }
                </div>

                <h2>{this.getTranslation("menu.aboutus")}</h2>
                {typeof window !== "undefined" &&
                <div ref={(ref) => {this.Text = ref}} dangerouslySetInnerHTML={{__html: agt.Text}}></div>
                }

              </div>
            </div>

            <div className="bottom-side">
              <div className="contact-details-wrapper">
                <h3>{this.getTranslation("page.profile.contactinfo")}</h3>

                {!wActs.isNullOrEmpty(host) &&
                <div className="contact-item">
                  <span className="icon"><img src="/imgs/web-icon.svg" alt="Website"/></span>
                  <span className="text"><a href={agt.WebPageUrl} target={"_blank"}>{host}</a></span>
                </div>
                }

                {!wActs.isNullOrEmpty(agt.PhoneNumber1) &&
                  <div className="contact-item">
                    <span className="icon"><img src="/imgs/phone-icon.svg" alt="Phone"/></span>
                    <span className="text">{agt.PhoneNumber1}</span>
                  </div>
                }
                {!wActs.isNullOrEmpty(agt.PhoneNumber1) && !wActs.isNullOrEmpty(agt.PhoneText1) &&
                  <div className=" mini-grey-box">
                    <h6 style={{padding: "4px 0px"}}>{this.getTranslation("page.profile.phoneinstructions")}</h6>
                    <p>{agt.PhoneText1}</p>
                  </div>
                }
                {!wActs.isNullOrEmpty(agt.PhoneNumber2) && agt.PhoneNumber2 !== agt.PhoneNumber1 &&
                  <React.Fragment>
                  <div className="contact-item">
                    <span className="icon"><img src="/imgs/phone-icon.svg" alt="Phone"/></span>
                    <span className="text">{agt.PhoneNumber2}</span>
                  </div>
                  {!wActs.isNullOrEmpty(agt.PhoneText2) &&
                    <div className=" mini-grey-box">
                      <h6 style={{padding: "4px 0px"}}>{this.getTranslation("page.profile.phoneinstructions")}</h6>
                      <p>{agt.PhoneText1}</p>
                    </div>
                  }
                  </React.Fragment>
                }

                {agt.HasWhatsApp &&
                  <div className=" contact-item">
                    <span className="icon"><img src=" /imgs/whatsapp-icon.png" alt="Whatsapp"/></span>
                    <span className="text">{agt.PhoneNumber1}</span>
                  </div>
                }
                {agt.HasViber &&
                  <div className=" contact-item">
                    <span className="icon"><img src=" /imgs/viber-icon.png" alt="Viber"/></span>
                    <span className="text">{agt.PhoneNumber1}</span>
                  </div>
                }
                {agt.HasTelegram &&
                  <div className=" contact-item">
                    <span className="icon"><img src=" /imgs/telegram-icon.png" alt="Telegram"/></span>
                    <span className="text">{agt.PhoneNumber1}</span>
                  </div>
                }
                {agt.HasSkype &&
                  <div className="contact-item">
                    <span className="icon"><img src="/imgs/skype-icon.png" alt="Skype"/></span>
                    <span className="text">{agt.Skype}</span>
                  </div>
                }
                {!wActs.isNullOrEmpty(agt.Home) && !wActs.isNullOrEmpty(agt.Home.Address) &&
                <div className=" mini-grey-box">
                  <p>{agt.Home.Address}</p>
                </div>
                }
              </div>
              <div className="company-escorts-wrapper">
                <div className="agency-escorts-listing">
                  {agt.Profiles.map((v,i) => {
                    let purl = new URL(v.Url);
                    let ppath = purl.pathname;
                    return (
                      <div className="escort-item" key={"escort-" + i}>
                        <Link to={ppath} title={this.props.WebPage.Page.AltText.replace("{{Number}}",(i+2)) + " - " + v.EscortName} className="image">
                          <img src={v.ImageUrl} alt={this.props.WebPage.Page.AltText.replace("{{Number}}",(i+2)) + " - " + v.EscortName} style={{width: "100%"}} />
                          <div className="bottom-content">
                            <h4>{v.EscortName}</h4>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Agent: state.Agency.AgencyPages
  };
};

export default connect(mapStateToProps)(Agency);
